<!--
 * @Description: 项目根组件
 -->
<template>
  <div id="app" name="app">
    <el-container>
      <!-- 顶部导航栏 -->
<!--      <div class="topbar"></div>-->
      <!-- 顶部导航栏END -->

      <!-- 顶栏容器 -->
      <!-- <el-header :class="{ 'home-header': true, 'home-header-fixed': show }">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#fff"
          text-color="#555555"
          router
        >
          <div class="logo">
            <router-link to="/">
              <img src="./assets/imgs/home/logo.png" alt />
            </router-link>
          </div>
          <el-menu-item index="/"
            ><span>PRODUCT</span> <span class="caret"></span
          ></el-menu-item>
          <el-menu-item index="home"
            ><span>HOME</span> <span class="caret"></span
          ></el-menu-item>
          <el-menu-item index="services"
            ><span>SERVICES</span> <span class="caret"></span
          ></el-menu-item>
          <el-menu-item index="FAQ"
            ><span>FAQ</span> <span class="caret"></span
          ></el-menu-item>
          <el-menu-item index="contact"
            ><span>CONTACT</span> <span class="caret"></span
          ></el-menu-item>
          <el-menu-item index="login" v-if="!islogin"
            ><span style="text-decoration: none !important"
              >Login</span
            ></el-menu-item
          >
          <div v-if="islogin" style="line-height: 60px">
            <el-dropdown>
              <span class="el-dropdown-link" style="font-weight: bold">
                {{ nickname }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="tofootmark()"
                  >footmark</el-dropdown-item
                >
                <el-dropdown-item @click.native="tocollect()">Collect</el-dropdown-item>
                <el-dropdown-item>logout</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-menu>
      </el-header> -->
      <!-- 顶栏容器END -->

      <!-- 登录模块 -->
<!--      <MyLogin></MyLogin>-->
      <!-- 注册模块 -->
<!--      <MyRegister :register="register" @fromChild="isRegister"></MyRegister>-->

      <!-- 主要区域容器 -->
      <el-main>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </el-main>
      <!-- 主要区域容器END -->

      <!-- 底栏容器 -->
<!--      <el-footer>
        <div class="footer">
          <div class="content">
            <div class="left">
              Copyright (c) 2015 - 2016, YourCompany; all rights reserved.
            </div>
            <div class="right">
              Template by Bootstrapious. Ported to Hugo by DevCows
            </div>
          </div>
        </div>
      </el-footer>-->
      <!-- 底栏容器END -->
    </el-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  mounted() {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style>
/* 全局CSS */
* {
  padding: 0;
  margin: 0;
  border: 0;
  list-style: none;
}
#app .el-header {
  padding: 0;
}
#app .el-main {
  min-height: 300px;
  padding: 20px 0;
  padding-top: 0px;
  padding-bottom: 0px;
}
#app .el-footer {
  padding: 0;
}
#app .el-aside {
  padding: 20px 0;
}
#app .el-footer {
  padding: 0;
}
#app .el-footer {
  padding: 0;
}
#app .el-footer {
  padding: 0;
}
#app .el-footer {
  padding: 0;
}
#app .el-footer {
}
#app .el-footer {
  padding: 0;
}
a,
a:hover {
  text-decoration: none;
}
/* 全局CSS END */

/* 顶部导航栏CSS */
.topbar {
  height: 40px;
  background-color: #3d3d3d;
  /* margin-bottom: 10px; */
}
.topbar .nav {
  width: 1225px;
  margin: 0 auto;
}
.topbar .nav ul {
  float: right;
}
.topbar .nav li {
  float: left;
  height: 40px;
  color: #b0b0b0;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  margin-left: 20px;
}
.topbar .nav .sep {
  color: #b0b0b0;
  font-size: 12px;
  margin: 0 5px;
}
.topbar .nav li .el-button {
  color: #b0b0b0;
}
.topbar .nav .el-button:hover {
  color: #fff;
}
.topbar .nav li a {
  color: #b0b0b0;
}
.topbar .nav a:hover {
  color: #fff;
}
.topbar .nav .shopCart {
  width: 120px;
  background: #424242;
}
.topbar .nav .shopCart:hover {
  background: #fff;
}
.topbar .nav .shopCart:hover a {
  color: #ff6700;
}
.topbar .nav .shopCart-full {
  width: 120px;
  background: #ff6700;
}
.topbar .nav .shopCart-full a {
  color: white;
}
/* 顶部导航栏CSS END */

/* 顶栏容器CSS */
.el-header .el-menu {
  max-width: 1225px;
  margin: 0 auto;
}
.el-header .logo {
  height: 60px;
  width: 189px;
  float: left;
  margin-right: 380px;
}
.el-header .so {
  margin-top: 10px;
  width: 300px;
  float: right;
}
/* 顶栏容器CSS END */

.footer .ng-promise-box {
  /* border-bottom: 1px solid #3d3d3d; */
  line-height: 145px;
}
.footer .ng-promise-box {
  margin: 0 auto;
  /* border-bottom: 1px solid #3d3d3d; */
  line-height: 145px;
}
.footer .ng-promise-box .ng-promise p a {
  color: #fff;
  font-size: 20px;
  margin-right: 210px;
  padding-left: 44px;
  height: 40px;
  display: inline-block;
  line-height: 40px;
  text-decoration: none;
  background: url("./assets/imgs/us-icon.png") no-repeat left 0;
}
.footer .github {
  height: 50px;
  line-height: 50px;
  margin-top: 20px;
}
.footer .github .github-but {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  background: url("./assets/imgs/github.png") no-repeat;
}
.footer .mod_help {
  text-align: center;
  color: #888888;
}
.footer .mod_help p {
  margin: 20px 0 16px 0;
}

.footer .mod_help p a {
  color: #888888;
  text-decoration: none;
}
.footer .mod_help p a:hover {
  color: #fff;
}
.footer .mod_help p span {
  padding: 0 22px;
}
/* 底栏容器CSS END */
.navbar {
  width: 700px;
  /* float: right; */
}
</style>
<style lang="less" scoped>
.home-header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  padding: 35px 0;
  .home-picture,
  .home-hot {
    display: none;
  }
}
/* 底栏容器CSS */
.footer {
  background: #333;
  color: #ccc;
  padding: 50px 0;
  font-size: 12px;
  // line-height: 28px;
  .content {
    max-width: 1140px;
    margin: 0 auto;
    .right {
      float: right;
    }
    .left {
      float: left;
    }
  }
}
</style>
<style scoped>
/* 覆盖Element UI的默认样式 */
.el-menu-item.is-active {
  background-color: #38a7bb !important; /* 你想要的颜色 */
  text-decoration: none;
}
.el-menu.el-menu--horizontal {
  border: none !important;
}
.el-menu--horizontal > .el-menu-item.is-active span {
  border-bottom: none !important;
}
.el-menu-item span {
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold;
}
/* .caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
} */
.el-submenu {
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold !important;
}
.el-submenu__icon-arrow {
  display: none !important;
}
.el-submenu__title * {
  vertical-align: unset !important;
}
.el-menu-demo {
  --hover-color: #f0f9ff !important; /* 自定义悬浮颜色变量 */
}

.el-menu-item:hover {
  background-color: rgb(
    56 167 187 / 60%
  ) !important; /* 使用变量设置悬浮背景色 */
}
.el-submenu .el-submenu__title:hover {
  background-color: rgb(
    56 167 187 / 60%
  ) !important; /* 使用变量设置悬浮背景色 */
}
::v-deep .el-submenu__title i {
  font-weight: bold !important;
  color: #333 !important;
}

</style>